import * as Yup from "yup";

import { AccountPeriodsNames, wrapClick } from "utils";
import { Modal, RegularSelectInput } from "components";
import { SendTreatyBrokerNotes, SendTreatyBrokerNotesVariables } from "_graphql/mutation/__generated__/SendTreatyBrokerNotes";
import { useMatch, useSearch } from "react-location";
import { useTreaty, useTreatyReinsurer } from "hooks/data/use-treaties";

import { LocationGenerics } from "router/location";
import { SendEmailForm } from "components/forms";
import _ from "lodash";
import { sendTreatyBrokerNotes } from "_graphql/visal/mutations/treaty";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMemo } from "react";
import { useMutation } from "@apollo/client";

export const validationSchema = Yup.object().shape({
    message: Yup.string().required("Message is required"),
    subject: Yup.string().required("Subject is required"),
});

export default function SendDocumentsNonProportionalContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const { params } = useMatch<LocationGenerics>();
    const searchParams = useSearch<LocationGenerics>();
    const { treaty, loading: gettingTreaty } = useTreaty({ treatyId: params.treaty || "" });
    const [create, { loading }] = useMutation<SendTreatyBrokerNotes, SendTreatyBrokerNotesVariables>(sendTreatyBrokerNotes, {
        refetchQueries: ["Treaty"],
    });
    const { participant, loading: fetchingParticipant } = useTreatyReinsurer({ participationId: searchParams?.id || "" });

    const layer = useMemo(() => JSON.parse(treaty?.layer_limit || "[]").at(searchParams?.layer), [treaty?.layer_limit])


    const form = useFormik<any>({
        initialValues: {
            copied_emails: [],
            subject: "",
            message: "",
            include_attachment: false,
            should_send: 0,
            doc_type: []
        },
        validationSchema: validationSchema,
        onSubmit: async (variables) => {
            await create({
                variables: {
                    treaty_account_id: variables.quarter || "",
                    re_broker_treaties_participation_id: searchParams?.id || "",
                    treaty_id: params.treaty || "0",
                    emaildata: {
                        attachments: variables.attachments?.map((el: any) => el?.file_path) || [],
                        copied_email: variables.copied_emails?.map((el: any) => el) || [],
                        subject: variables.subject,
                        email_content: variables.message,
                        // installment_type: layer?.installment_type || "",
                        // layer: Number(searchParams?.layer) || 0,
                        // limit: layer?.limit || "",
                        // m_and_d_premium: numeral(layer?.m_and_d_premium).value(),
                        // participant_id: Number(participant?.treaty_participation_id) || -1,
                        // total_participation_percentage: participant?.treaty_participation_percentage,
                        // treaty_id: Number(params.treaty || "0"),
                        // uuid: searchParams?.id || "",
                    }
                },
            }).then(({ data }) => {
                if (data?.sendTreatyBrokerNotes) {
                    toast.success("Emails sent successfully");
                    refetch?.();
                    form.resetForm();
                } else {
                    toast.error("Failed to send emails");
                }
            });
        },
        onReset: () => {
            setOpen(false);
        },
    });

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            loading={fetchingParticipant || gettingTreaty}
            title={"Send Credit Note"}
            description="Draft an email to send to the participant(s) of this treaty."
            renderActions={() => (
                <>
                    <button
                        type="button"
                        disabled={loading}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={wrapClick(form.handleSubmit)}
                    >
                        {loading ? "Sending emails..." : "Send Email"}
                    </button>
                </>
            )}
        >
            <SendEmailForm form={form} topForm={<div className="">
                <div className="bg-red-50 rounded-lg shadow-sm border border-red-200 p-4 mb-4 space-y-2">
                    <p className="text-sm  text-red-800 rounded-md">
                        This session will send a copy of closing slip to {" "}
                        <strong>{participant?.reinsurer?.re_company_name}</strong> as
                        attachment
                    </p>
                    <p className="text-sm  text-red-800 rounded-md">
                        <strong>N.B:</strong> You can include any number of EMAILS. Press ENTER or TAB key to
                        add more{" "}
                    </p>
                </div>


                <div >
                    <RegularSelectInput
                        id="quarter"
                        label="Quarter"
                        placeholder="Select Quarter"
                        options={[...treaty?.treaty_accounts?.map((el: any) => ({
                            label: _.get(AccountPeriodsNames, el?.account_periods || ""),
                            value: el?.treaty_account_id || "",
                        })) || []]}
                        {...form}
                    />
                </div>

            </div>} />
        </Modal>
    );
}
